import PhaseOne from "components/Participant/CompleteSelfServey/SurveyPhase/PhaseOne"
import React from "react"

const PhaseOnePage = () => {
    return (
        <React.Fragment>
            <PhaseOne />
        </React.Fragment>
    )
}
export default PhaseOnePage
